import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Automationprocess() {
  return (
    <section className="automation-process p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <h2>
              An Streamlined <span>Automation</span> Process
            </h2>
          </Col>
        </Row>
        <Row className="mt-4 mt-md-5">
          <Col xs={12} md={4} lg={4} xl={3} xxl={3} className="mb-4 mb-xl-0">
            <div className="process-box">
              <div className="num">01</div>
              <h5>
                Consultation &<br className="d-none d-lg-block" />
                Assessment
              </h5>
              <p>
                Personalized assessment to identify key processes suitable for
                automation.
              </p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={3} xxl={3} className="mb-4 mb-xl-0">
            <div className="process-box">
              <div className="num">02</div>
              <h5>
                Solution
                <br className="d-none d-lg-block" />
                Design
              </h5>
              <p>
                Tailored automation strategies aligning with your business
                objectives.
              </p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={3} xxl={3} className="mb-4 mb-xl-0">
            <div className="process-box">
              <div className="num">03</div>
              <h5>
                Implementation &
                <br className="d-none d-lg-block" />
                Integration
              </h5>
              <p>
                Seamless deployment of Process Automation Tools into your
                business ecosystem.
              </p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={3} xxl={3} className="">
            <div className="process-box">
              <div className="num">04</div>
              <h5>
                Optimization &
                <br className="d-none d-lg-block" />
                Support
              </h5>
              <p>
                Ongoing support and continuous improvement to maintain peak
                performance.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Automationprocess;
